export const themes = {
	'default-dark': {
		"--background-one": "#424242",
		"--background-two": "#222222",
		"--background-one-font": "#fafafa",
		"--background-two-font": "#ffffff",
		"--primary-one": "#fafafa",
		"--primary-two": "0 145 234",
		"--primary-three": "#f1c232",
		"--secondary-one": "#c2c2c2",
		"--secondary-two": "#9f9f9f",
		"--secondary-three": "#9e9e9e",
		"--secondary-four": "#323232",
		"--secondary-five": "#bdbdbd",
		"--secondary-six": "#b0b0b0",
		"--secondary-seven": "#e0e0e0",
		"--success": "#40b630",
		"--error": "#ff151f",
		"--warning": "#ff9c00"
	},
	default: {
		'--background-one': '#ffffff',
		'--background-two': '#fafafa',
		'--background-one-font': '#222222',
		'--background-two-font': '#424242',
		'--primary-one': '#000000',
		'--primary-two': '0 145 234',
		'--primary-three': '#f1c232',
		'--secondary-one': '#424242',
		'--secondary-two': '#757575',
		'--secondary-three': '#9e9e9e',
		'--secondary-four': '#eeeeee',
		'--secondary-five': '#bdbdbd',
		'--secondary-six': '#606060',
		"--secondary-seven": "#e0e0e0",
		'--success': '#40b630',
		'--error': '#ff151f',
		'--warning': '#ff9c00'
	}
};
